const { BASE_URL } = require("./client");

const GET_FORM = BASE_URL + "/api/form/get";

module.exports = {
  GET_FORM,
};
